import React from 'react';
import Toast from './Toast';
import _ from 'lodash';

class DefaultToast extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
    };

    _.map(['handleClose'], (fn) => {
      this[fn] = this[fn].bind(this);
    });
  }

  componentDidMount() {
    this.setState({ ...this.state, isOpen: true });
  }

  handleClose() {
    const { onClose } = this.props;

    if (onClose) {
      onClose();
    }

    this.setState({ ...this.state, isOpen: false });
  }

  render() {
    const { customClass, children } = this.props;
    const { isOpen } = this.state;

    return (
      <Toast
        open={isOpen}
        onClose={this.handleClose}
        timer={10000}
        classes={{ options: customClass }}
      >
        {children}
      </Toast>
    );
  }
}

export default DefaultToast;
